import { Select } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { getSteps } from "../api/courses.api";
import useAxios from "../hooks/useAxios";
import { IGetSteps } from "../models/courses.model";
import ErrorResponse from "./ErrorResponse";
import Loader from "./Loader";

interface IProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectLevelWithAll: FC<IProps> = ({
  value,
  setValue,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetSteps>();

  const [steps, setSteps] = useState<any>();

  useEffect(() => {
    execute(getSteps());
  }, []);

  useEffect(() => {
    if (res && !isLoading) {
      const _steps: any = [];
      res?.data?.forEach(item => {
        item?.step?.forEach(subitem => {
          _steps.push(subitem);
        });
      });
      setSteps(_steps);
    }
  }, [res, isLoading]);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Select
        className="w-100"
        value={value}
        onChange={value => setValue(value)}
      >
        <Select.Option value="">{t('common.text.all')}</Select.Option>
        {steps?.map((item: any) => (
          <Select.Option
            key={item.courseCode}
            value={item.courseCode}
          >
            {item.courseName}
          </Select.Option>
        ))}
      </Select>
    </>
  );
}

export default SelectLevelWithAll;
